type PricingOrderCheckParams = {
  isLogin: boolean
  selectedPlan: { isSubscription: boolean } | null
  couponFetching: boolean
  listFetching: boolean
  subscriptionAgreementChecked: boolean
}

export const canCreatePricingOrder = ({
  isLogin,
  selectedPlan,
  couponFetching,
  listFetching,
  subscriptionAgreementChecked,
}: PricingOrderCheckParams) => {
  if (!selectedPlan || !isLogin || couponFetching || listFetching) {
    return false
  }

  if (selectedPlan.isSubscription && !subscriptionAgreementChecked) {
    return false
  }

  return true
}
